function assert(key: string, value?: string) {
    if (value == null || !value.length) {
        throw new Error(key + " is missing");
    }
    return value;
}

const nonLocalAppEnvNames = ["production", "staging", "development"];

const isLocalDev =
    nonLocalAppEnvNames.indexOf(
        assert("APP_ENV_NAME", process.env.APP_ENV_NAME)
    ) === -1;

interface Config {
    appEnvName: string;
    apiBaseUrl: string;
    firebase: {
        apiKey: string;
        authDomain: string;
        databaseURL: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    };
    zeus: {
        endpointTokenApi: string;
        sdkUrl: string;
        clientIp: string;
    };
    sentry: {
        dnsUrl: string;
    };
}

export function getAppConfig(): Config {
    return {
        appEnvName: assert("APP_ENV_NAME", process.env.APP_ENV_NAME),
        apiBaseUrl: isLocalDev
            ? `http://${window.location.hostname}:1060`
            : assert("API_BASE_URL", process.env.API_BASE_URL),
        firebase: {
            apiKey: assert("FIREBASE_API_KEY", process.env.FIREBASE_API_KEY),
            authDomain: assert(
                "FIREBASE_AUTH_DOMAIN",
                process.env.FIREBASE_AUTH_DOMAIN
            ),
            databaseURL: assert(
                "FIREBASE_DATABASE_URL",
                process.env.FIREBASE_DATABASE_URL
            ),
            projectId: assert(
                "FIREBASE_PROJECT_ID",
                process.env.FIREBASE_PROJECT_ID
            ),
            storageBucket: assert(
                "FIREBASE_STORAGE_BUCKET",
                process.env.FIREBASE_STORAGE_BUCKET
            ),
            messagingSenderId: assert(
                "FIREBASE_MESSAGING_SENDER_ID",
                process.env.FIREBASE_MESSAGING_SENDER_ID
            ),
            appId: assert("FIREBASE_APP_ID", process.env.FIREBASE_APP_ID)
        },
        zeus: {
            endpointTokenApi: assert(
                "ZEUS_TOKEN_URL",
                process.env.ZEUS_TOKEN_URL
            ),
            sdkUrl: assert("ZEUS_SDK_URL", process.env.ZEUS_SDK_URL),
            clientIp: assert(
                "ZEUS_AUTHENTICATION_CLIENTIP",
                process.env.ZEUS_AUTHENTICATION_CLIENTIP
            )
        },
        sentry: {
            dnsUrl: assert("SENTRY_DSN_WEB", process.env.SENTRY_DSN_WEB)
        }
    };
}
